import React from 'react';
import { Reveal } from './Reveal';
const testimonials = [{
  initials: 'CH',
  stars: 5,
  plan: "KIT + VACACIONES\xA0 PRESENTES",
  quote: 'Lo que más valoro es que las dinámicas no son forzadas. Se sienten cercanas y eso ayuda mucho cuando el tiempo es poco.',
  avatar: 'https://cdn.magicpatterns.com/uploads/hRkBmK12uRYGgN3bYKcCVT/2.png'
}, {
  initials: 'SB',
  stars: 4,
  plan: 'Kit Padres Presentes',
  quote: 'Me sirvió bastante para ordenar ideas que ya venía trabajando. Lo mejor es que se puede usar sin sentirse rígido o demasiado estructurado.',
  avatar: 'https://cdn.magicpatterns.com/uploads/kh7gS5ziy8yMVhNQpbs3Uu/7.png'
}, {
  initials: 'PS',
  stars: 5,
  plan: "KIT + VACACIONES PRESENTES",
  quote: 'Es de esos materiales que se sienten simples, pero están bien pensados. Lo recomiendo especialmente si querés ahorrar tiempo preparando actividades.',
  avatar: 'https://cdn.magicpatterns.com/uploads/uyBU7TuqpQCSz3ZU1YjeAE/3.png'
}, {
  initials: 'EC',
  stars: 4,
  plan: 'Kit Padres Presentes',
  quote: 'Muy útil y fácil de aplicar. Le pondría 5 estrellas si incluyera más variantes por edades, pero aun así cumple muy bien.',
  avatar: 'https://cdn.magicpatterns.com/uploads/7RJauYxbBEcAU18gmhxzYg/6.png'
}];
export function TestimonialsSecondary() {
  return <section aria-label="Más testimonios" className="w-full bg-cream-200 py-16 sm:py-24" data-id="element-214" data-mp="1yqfcm3dmh5jl">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-215" data-mp="23prvye5abuhf">
        <Reveal data-id="element-216" data-mp="23p8ppuozyuj8">
          <h2 className="text-center font-display text-2xl font-semibold tracking-tight text-bark-900 sm:text-3xl" data-id="element-217" data-mp="23nnvy7aibfmf">
            Lo que dicen otros padres y madres
          </h2>
        </Reveal>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-218" data-mp="2dgd2cnr7a3aw">
          {testimonials.map((t, i) => <Reveal key={t.initials} delay={i * 0.06} data-id="element-219" data-mp="2ie4xdqn565jb" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-3xl border border-bark-800/[0.08] bg-cream-50 p-6 shadow-sm" data-id="element-220" data-mp="2mgrsq1j0u8l9">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-id="element-221" data-mp="2rge4e6j7bgry">
                  <img src={t.avatar} alt={`Foto de ${t.initials}`} loading="lazy" className="h-10 w-10 shrink-0 rounded-full bg-terracotta-100 object-cover" data-id="element-222" data-mp="rcle4sam1378" />
                  <span aria-label={`${t.stars} de 5 estrellas`} className="text-sm" data-id="element-223" data-mp="n9f191szsdrs">
                    {'⭐'.repeat(t.stars)}
                  </span>
                  <span className="rounded-full bg-cream-200 px-2.5 py-1 text-[0.65rem] font-semibold uppercase tracking-wider text-bark-400" data-id="element-224" data-mp="wb50gtt48h04">
                    {t.plan}
                  </span>
                </div>
                <blockquote className="mt-4 text-[0.95rem] leading-relaxed text-bark-600" data-id="element-225" data-mp="161hjghla8245">
                  “{t.quote}”
                </blockquote>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}